import { Field } from 'formik'
import { Select as _Select } from 'formik-material-ui'
import React from 'react'

const Select = (props) => {
  return <Field component={_Select} {...props} />
}

export default Select
